﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'form-submit-button',
    props: ['blockids'],
    methods: {

    }, 
    computed:
        Object.assign( 
            mapState({
                validatedBlocks: state => state.checkout.form
            }),
            { 
                stateInvalid() {
                    let res = false;
                    if (this.validatedBlocks && this.blockids) {
                        for (var l = 0; l < this.blockids.length; l++) { //Iterate blocks on current page
                            for (var i = 0; i < this.validatedBlocks.length; i++) { //Iterate validated blocks from state
                                if (this.blockids[l] == this.validatedBlocks[i].blockId && this.validatedBlocks[i].invalid != false) {
                                    res = true;
                                }
                            }
                        } 
                    } 
                    return res;  
                }
            }
    ),
} 